/** Same rule as the API's `tenantSlugSchema`: 2–64 chars, lowercase letters/digits, single hyphens. */
const SLUG = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

/**
 * MT-1 Plan 6 S16 (FR-20): the school address a visitor types. Accepts `sunrise-yoga`,
 * `/t/sunrise-yoga`, or a whole link (`https://host/t/sunrise-yoga/login`). Returns the slug, or
 * null when it is not a valid address.
 */
export function parseSchoolAddress(input: string): string | null {
  let text = input.trim().toLowerCase();
  if (!text) return null;
  const inPath = /\/t\/([^/?#\s]+)/.exec(text);
  if (inPath) text = inPath[1]!;
  else if (/^[a-z][a-z0-9+.-]*:\/\//.test(text)) return null;
  text = text.replace(/^\/+|\/+$/g, "");
  return text.length >= 2 && text.length <= 64 && SLUG.test(text) ? text : null;
}
